import React, { useEffect, useRef, useState } from "react";
import { Switch, useLocation } from "react-router-dom";
import LoadingBar from "react-top-loading-bar";
import { PAGES } from "~/constants";
import { useAppDispatch } from "~/hooks";
import { injectGTM } from "~/redux/ui/slice";

type LoadingBarRef = {
  add(value: number): void;
  decrease(value: number): void;
  continuousStart(startingValue?: number, refreshRate?: number): void;
  staticStart(startingValue: number): void;
  complete(): void;
};

export function CustomSwitch({ children }: any) {
  const dispatch = useAppDispatch();
  const ref = useRef<LoadingBarRef>(null);
  const [prevLoc, setPrevLoc] = useState("");
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.includes(`s${PAGES.VOTES}`)) {
      dispatch(injectGTM({ value: true }));
    }

    setPrevLoc(location.pathname);
    ref?.current?.continuousStart();
    if (location.pathname === prevLoc) {
      setPrevLoc("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    ref?.current?.complete();
  }, [prevLoc]);

  return (
    <>
      <LoadingBar color="#fb8c00" ref={ref} />
      <Switch>{children}</Switch>
    </>
  );
}
